import { AbstractPreset, config } from "./AbstractPreset";

export default class CircleNoneRadial extends AbstractPreset {
	getName(): string {
		return 'circleNoneRadial';
	}

	getConfig(): config {
		return {
			"base": {
				"shape": "circle",
				"presetShape": this.getName(),
				"primitives": {
					"diameter": 50
				},
			},
			"drillholes": {
				"type": "radial",
				"amount": 10,
				"position": {
					"left": 250,
					"bottom": 250
				},
				"radialDiameter": 350,
				"diameter": 20
			},
			"cutouts": [],
		};
	}

}
